import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledSignatureItems = styled.div`
  flex-direction: column;
  height: 100%;

  @media ${baseVariables.mediaQuery.lg} {
    flex-direction: row;
  }

  .signature-items {
    width: -webkit-fill-available;

    &__content-container {
      word-break: break-word;
      flex: 1;

      &__content {
        @media ${baseVariables.mediaQuery.lg} {
          margin-left: ${toRem(96)};
          margin-right: ${toRem(64)};
        }
      }
    }
  }

  .item-without-image {
    max-width: 50%;
  }

  .carousel-img-container {
    background-size: cover;
    background-position: center;
    border-radius: ${toRem(14)};
    width: 100%;

    @media ${baseVariables.mediaQuery.md} {
      flex: 1;
    }

    img {
      width: 100%;
      height: 100%;
      border-radius: ${toRem(14)};
      aspect-ratio: 3/2;

      @media ${baseVariables.mediaQuery.lg} {
        aspect-ratio: 1/1;
      }
    }
  }

  .location-info {
    width: 100%;
    border-top: 1px solid ${baseVariables.color.neutral30};
    border-bottom: 1px solid ${baseVariables.color.neutral30};
  }

  .truncated-description {
    display: -webkit-box;
    -webkit-line-clamp: 8;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .full-description {
    display: block;
  }

  .show-more-button,
  .show-more-button:hover,
  .show-more-button:focus {
    background: none;
  }

  .show-more-icon {
    vertical-align: middle;

    &::before {
      font-size: ${toRem(20)};
      line-height: ${toRem(20)};
    }
  }
`;
